import { createContext, useContext } from 'react';

import { TAbstractEntity } from './Editor/interface';

export function genEditorContext<TEntity extends TAbstractEntity>() {
  const ctx = createContext(null as unknown as TContextValue<TEntity>);
  ctx.displayName = 'EditorContext';

  return {
    ctx,
    useEditor: (): TContextValue<TEntity> => useContext(ctx),
  };
}

export type TContext<TEntity extends TAbstractEntity> = React.Context<
  TContextValue<TEntity>
>;

export type TContextValue<TEntity extends TAbstractEntity> = {
  editEntity: (entity: string) => Promise<TEntity | null>;
  createEntity: (containerUid: string) => Promise<TEntity | null>;
};
